export const BRAND = {
  name: "DriveFlow",
  fullName: "DriveFlow Technologies",
  tagline: "Une seule app, 30 secondes par course, à partir de 0 € par mois.",
  logoUrl: "/brand/logo-680.webp",
  logoGif:
    "https://customer-assets.emergentagent.com/job_driver-hub-154/artifacts/arr7lr4s_fais_une_belle_animation_moder-ezgif.com-video-to-gif-converter-2-2.gif",
  origin: "Conçu à Brest, 100 % made in France",
  pricing: {
    monthlyHT: 29.99,
    monthlyTTC: 35.99,
    vatRate: 20,
  },
  contactEmail: "contact@driveflowtechnologies.fr",
};

export const NAV_LINKS = [
  { id: "fonctionnalites", label: "Fonctionnalités" },
  { id: "tarifs", label: "Tarifs" },
  { id: "histoire", label: "Notre histoire" },
  { id: "faq", label: "FAQ" },
];
